import { DataTable, Column, Badge } from '../../../../shared/components';
import { ValidationError, ValidationMotivo } from '../../../../shared/services/results/types';

const MOTIVO_LABEL: Record<ValidationMotivo, string> = {
  CUENTA_SIN_REPORTE: 'Cuenta sin reportar (en $0 para todos los clientes)',
  VALOR_MUY_PEQUENO: 'Valor muy pequeño (< $10.000)',
  VALOR_NEGATIVO: 'Valor negativo',
  TOTAL_NO_CUADRA: 'El total calculado no coincide con el del archivo',
  CLIENTE_SIN_TIPO_SERVICIO: 'Cliente sin Tipo de Servicio en Parámetros',
};
const MOTIVO_TONE: Record<ValidationMotivo, 'neutral' | 'warning' | 'critical'> = {
  CUENTA_SIN_REPORTE: 'neutral',
  VALOR_MUY_PEQUENO: 'neutral',
  VALOR_NEGATIVO: 'warning',
  TOTAL_NO_CUADRA: 'critical',
  CLIENTE_SIN_TIPO_SERVICIO: 'warning',
};

const money = (v: number | null) => (v == null ? '—' : v.toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }));

/**
 * Tabla "Por revisar": ya no hay una segunda hoja contra la cual comparar
 * (el archivo mensual solo trae Ingresos/Egresos), así que esto muestra
 * datos dudosos encontrados dentro de la propia hoja - nunca se oculta en
 * un modal, para que quede como evidencia auditable frente al comercial
 * incrédulo.
 */
export function ValidationErrorsTable({ errors }: { errors: ValidationError[] }) {
  const columns: Column<ValidationError>[] = [
    { key: 'cuenta', header: 'Cuenta', render: (e) => (e.cuentaDescripcion ? `${e.cuentaCodigo} · ${e.cuentaDescripcion}` : e.cuentaCodigo) },
    { key: 'cliente', header: 'Cliente', render: (e) => e.cliente ?? '(todos)' },
    { key: 'valor', header: 'Valor', render: (e) => money(e.valor) },
    { key: 'valorEsperado', header: 'Valor esperado (archivo)', render: (e) => money(e.valorEsperado) },
    { key: 'diferencia', header: 'Diferencia', render: (e) => money(e.diferencia), sortable: true, sortValue: (e) => e.diferencia ?? 0 },
    { key: 'motivo', header: 'Motivo', render: (e) => <Badge tone={MOTIVO_TONE[e.motivo]}>{MOTIVO_LABEL[e.motivo]}</Badge> },
  ];

  return (
    <DataTable
      columns={columns}
      rows={errors}
      rowKey={(e) => e.id}
      pageSize={10}
      pageSizeOptions={[5, 10, 25, 50]}
      emptyTitle="Sin datos por revisar"
      emptyDescription="No se encontraron cuentas sin reportar, valores atípicos ni totales descuadrados en este mes."
    />
  );
}
